import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, ApiClientError } from '../api';
import { ErrorBox, PageHeader } from '../components/Common';
import { useAuthStore } from '../store';

export function BecomeMasterPage() {
  const navigate = useNavigate();
  const refresh = useAuthStore((s) => s.refreshMe);
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [experience, setExperience] = useState('');
  const [about, setAbout] = useState('');

  const submit = useMutation({
    mutationFn: () =>
      api.admin.submitMasterApp({
        full_name: fullName,
        phone,
        experience: experience || undefined,
        about: about || undefined,
      }),
    onSuccess: async () => {
      await refresh();
    },
  });

  if (submit.isSuccess) {
    return (
      <div className="space-y-3">
        <PageHeader title="Заявка отправлена" />
        <div className="card">
          <p>Спасибо! Администратор рассмотрит её в ближайшее время.</p>
        </div>
        <button className="btn-primary w-full" onClick={() => navigate('/')}>
          На главную
        </button>
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Стать мастером" subtitle="Заполните анкету" />
      <div className="card space-y-3">
        <div>
          <label className="label">ФИО *</label>
          <input
            className="input"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
        </div>
        <div>
          <label className="label">Телефон *</label>
          <input
            className="input"
            value={phone}
            inputMode="tel"
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div>
          <label className="label">Опыт</label>
          <input
            className="input"
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            placeholder="Например, 3 года"
          />
        </div>
        <div>
          <label className="label">О себе</label>
          <textarea
            className="input min-h-[80px]"
            value={about}
            onChange={(e) => setAbout(e.target.value)}
          />
        </div>
        {submit.error && (
          <ErrorBox
            message={
              submit.error instanceof ApiClientError
                ? submit.error.message
                : (submit.error as Error).message
            }
          />
        )}
        <button
          className="btn-primary w-full"
          disabled={!fullName || !phone || submit.isPending}
          onClick={() => submit.mutate()}
        >
          {submit.isPending ? 'Отправляем...' : 'Отправить заявку'}
        </button>
      </div>
    </div>
  );
}
